import Button, { ButtonProps } from '@material-ui/core/Button';

import CircularProgress from '@material-ui/core/CircularProgress';
// eslint-disable-next-line
import React from 'react';
import { useFormikContext } from 'formik';
import { disableSubmit } from './helpers';

export type OuterProps = { loading?: boolean } & Partial<ButtonProps>;
const SubmitButton: React.FC<OuterProps> = ({
  children,
  disabled,
  loading,
  ...rest
}) => {
  const formik = useFormikContext();
  const finalDisabled = loading || (disabled ?? disableSubmit(formik));

  return (
    <Button
      disabled={finalDisabled}
      type="submit"
      size="medium"
      variant="contained"
      color="primary"
      {...rest}
    >
      {loading ? <CircularProgress size={24} /> : children}
    </Button>
  );
};
export default SubmitButton;
